import { ColorUtils } from "@awayjs/core";
var BitmapImageUtils = (function () {
    function BitmapImageUtils() {
    }
    BitmapImageUtils._fillRect = function (context, rect, color, transparent) {
        if ((color & 0xff000000) >>> 24 != 0xFF && transparent)
            context.clearRect(rect.x, rect.y, rect.width, rect.height);
        var argb = ColorUtils.float32ColorToARGB(color);
        if (transparent)
            context.fillStyle = 'rgba(' + argb[1] + ',' + argb[2] + ',' + argb[3] + ',' + argb[0] / 255 + ')';
        else
            context.fillStyle = 'rgba(' + argb[1] + ',' + argb[2] + ',' + argb[3] + ',1)';
        context.fillRect(rect.x, rect.y, rect.width, rect.height);
    };
    BitmapImageUtils._copyPixels = function (context, bmpd, sourceRect, destPoint) {
        if (sourceRect.width > 0 && sourceRect.height > 0)
            context.drawImage(bmpd, sourceRect.x, sourceRect.y, sourceRect.width, sourceRect.height, destPoint.x, destPoint.y, sourceRect.width, sourceRect.height);
    };
    BitmapImageUtils._draw = function (context, source, matrix, colorTransform, blendMode, clipRect, smoothing) {
        context.save();
        if (matrix != null)
            context.setTransform(matrix.a, matrix.b, matrix.c, matrix.d, matrix.tx, matrix.ty);
        if (source instanceof Uint8Array) {
            if (clipRect != null) {
                var imageData = context.getImageData(0, 0, clipRect.width, clipRect.height);
                imageData.data = source;
                context.putImageData(imageData, 0, 0);
            }
            else {
                console.log("  no rect");
            }
        }
        else {
            if (clipRect != null)
                context.drawImage(source, clipRect.x, clipRect.y, clipRect.width, clipRect.height);
            else
                context.drawImage(source, 0, 0);
        }
        context.restore();
    };
    return BitmapImageUtils;
}());
export { BitmapImageUtils };



// WEBPACK FOOTER //
// ../dist/lib/utils/BitmapImageUtils.js